/**
 * Should be in the same order as the regex
 */
export const content_css: string[] = [
  '//fonts.googleapis.com/css2?family=Open+Sans',
  '//fonts.googleapis.com/css2?family=Roboto',
  '//fonts.googleapis.com/css2?family=Lato',
  '//fonts.googleapis.com/css2?family=Montserrat',
  '//fonts.googleapis.com/css2?family=Oswald',
  '//fonts.googleapis.com/css2?family=Source+Sans+Pro',
  '//fonts.googleapis.com/css2?family=Raleway',
  '//fonts.googleapis.com/css2?family=PT+Sans',
  '//fonts.googleapis.com/css2?family=Roboto+Slab',
  '//fonts.googleapis.com/css2?family=Merriweather',
  '//fonts.googleapis.com/css2?family=Ubuntu',
  '//fonts.googleapis.com/css2?family=Playfair+Display',
  '//fonts.googleapis.com/css2?family=Noto+Sans',
  '//fonts.googleapis.com/css2?family=Poppins',
  '//fonts.googleapis.com/css2?family=Lora',
  '//fonts.googleapis.com/css2?family=PT+Serif',
  '//fonts.googleapis.com/css2?family=Roboto+Mono',
  '//fonts.googleapis.com/css2?family=Arimo',
  '//fonts.googleapis.com/css2?family=Titillium+Web',
];

/**
 * Should be in the same order as the content_css
 */
export const font_url_regex: RegExp[] = [
  /\/\/fonts\.googleapis\.com\/css2?\?family=Open\+Sans/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Roboto/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Lato/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Montserrat/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Oswald/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Source\+Sans\+Pro/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Raleway/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=PT\+Sans/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Roboto\+Slab/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Merriweather/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Ubuntu/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Playfair\+Display/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Noto\+Sans/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Poppins/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Lora/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=PT\+Serif/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Roboto\+Mono/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Arimo/,
  /\/\/fonts\.googleapis\.com\/css2?\?family=Titillium\+Web/,
];
